var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 6.57464e-06H13C5.8305 6.57464e-06 0 5.81101 0 12.948V91.052C0 98.189 5.8305 104 13 104H32.5V130L73.7815 104H117C124.17 104 130 98.189 130 91.052V12.948C129.99 9.50815 128.615 6.2129 126.178 3.78542C123.741 1.35794 120.44 -0.00345225 117 6.57464e-06ZM58.5 77.441L34.4045 53.3455L43.5955 44.1545L58.5 59.059L89.6545 27.9045L98.8455 37.0955L58.5 77.441Z",
    fill: "#2AAADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified_icon.6b177efd5f16aecfd2ff41caa819a1ca.svg";
export { ForwardRef as ReactComponent };